export enum ManifestsDestinationOption {
    VCGS = "VCGS",
    GeneByGene = "GeneByGene"
}